<div class="post-puzzle-container dialog-container">
    <p style="text-align: center; color: #636DB3">
        Ułóż słowo z rozsypanych sylab
    </p>
    <div class="answers-container" cdkDropListGroup>        
        <div cdkDropList 
            cdkDropListSortingDisabled
            *ngFor="let part of answers; let i = index"
            class="answer"
            [id]="'part-'+i"
            [cdkDropListData]="part"
            (cdkDropListDropped)="drop($event)">
            <div *ngIf="part[0]" 
                class="box"
                cdkDrag 
                [cdkDragData]="part[0]">
                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                {{ part[0].text }}
            </div> 
        </div>                
             
        <div class="parts-items"
            cdkDropList
            cdkDropListSortingDisabled
            [cdkDropListData]="parts"
            (cdkDropListDropped)="drop($event)">
            <div cdkDrag 
                class="part-item-box"
                *ngFor="let part of parts" 
                [cdkDragData]="part"
                [style.backgroundColor]="part.color"> 
                {{ part.text }}
            </div>    
        </div>
    </div>

    <p style="text-align: center; color: #636DB3">
        <strong>{{post.game_puzzle_definition}}</strong>
    </p>

    <div *ngIf="showDialog();" 
        class="answer-dialog">
        <div class="close-button"
            (click)="closeDialog();">
            x
        </div>
        <div *ngIf="showDialogOk" class="correct">
            <h1>Juuhuuu!</h1>
            <p>Odgadłeś słowo!</p>
            <p><strong>{{post.game_puzzle_password}}</strong> - <i>{{post.game_puzzle_definition}}</i></p>
        </div>    
        <button *ngIf="post.next" 
            class="lite"
            [routerLink]="['/task', post.next]">
            Przejdź dalej
        </button>
        <button *ngIf="!post.next" 
            class="lite"
            routerLink="/categories">
            Powrót do kategorii
        </button>
    </div>
</div>